import React, { memo, MouseEvent } from 'react';
import classnames from 'classnames';
import { useDispatch } from 'react-redux';
import styles from './index.module.scss';

export type IndustryLabelProps = {
  name?: string;
  selected?: boolean;
  locked?: boolean;
  className?: string;
  onClick?: (e: MouseEvent<HTMLSpanElement>) => void;
};

const IndustryLabel: React.FC<IndustryLabelProps> = ({ name, selected, locked, className, onClick }) => {
  const dispatch = useDispatch();
  return (
    <div
      className={classnames(
        styles.label,
        { [styles.selectedLabel]: selected, [styles.lockedLabel]: locked },
        className
      )}
      onClick={e => {
        !locked ? onClick?.(e) : dispatch({ type: 'modal/openUserLoginModal', payload: 'login' });
      }}
    >
      <span>{name}</span>
      {locked && (
        <svg className={classnames('icon', styles.icon)} aria-hidden={true}>
          <use xlinkHref="#icon-lock" />
        </svg>
      )}
    </div>
  );
};

export default memo(IndustryLabel);
